<!-- =========================================================================================
  File Name: locationSettingSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <span class="flex items-center" style="word-break: normal;">
      <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }}
                SETTINGS FOR:</h4> 
                <vs-chip  color="primary" class="">
            <p >{{LocationName}}</p>
    </vs-chip>
      </span>
       
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <span v-if="$GlobalFunction.checkPermission('manage_location_billing')">
        <label>Maximum Number Of Students</label><br><br>
        <ul class="centerx flex">
          <li>
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="10">10</vs-radio>
          </li>
          <li>
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="25">25</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="50">50</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="100">100</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="1000">1000</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfStudents" vs-name="radios1" vs-value="5000">5000</vs-radio>
          </li>

        </ul>
        <br>
        <!-- <label>Maximum Number Of Users</label><br><br>

        <ul class="centerx flex">
          <li>
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="10">10</vs-radio>
          </li>
          <li>
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="25">25</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="50">50</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="100">100</vs-radio>
          </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="1000">1000</vs-radio>
           </li>
          <li class="ml-2">
            <vs-radio v-model="maxNoOfUsers" vs-name="radios2" vs-value="5000">5000</vs-radio>
          </li>

        </ul>
        <br> -->
        </span>
          <vs-row vs-w="12">
          <vs-col  vs-lg="7" vs-sm="7" vs-xs="7">
            <label>Max Daily Logins Feature</label>
          </vs-col>
           <vs-col  vs-lg="3" vs-sm="3" vs-xs="3">
          </vs-col>
          <vs-col vs-lg="2" vs-sm="2" vs-xs="5" vs-type="flex"><vs-switch @click="setMaxDailyLogins()" v-model="dataMaxDailyLoginFeature"></vs-switch></vs-col>
        </vs-row><br>
        <!-- MAX LOGIN ATTEMPT -->
        <div v-if="dataMaxDailyLoginFeature">
        <label>Number of Max Daily Logins</label>
          <span>  &nbsp;
            <vs-button size="small" v-if="dataMaxDailyLogins !=0" v-html="dataMaxDailyLogins"></vs-button>
            <vs-button size="small" v-else >N/A</vs-button>
          </span>
        <vs-slider :max="10" :min="1" v-model="dataMaxDailyLogins" /></div>
        <!-- MAX LOGIN ATTEMPT -->
       <br>
        <label>User Time Out</label> <span>
        &nbsp;
        <vs-button size="small" v-if="dataUserTimeOut && dataUserTimeOut > 0" v-html="dataUserTimeOut+' Minutes'">]</vs-button>
        <vs-button size="small" v-else v-html="'N/A'"></vs-button>
        <vs-button v-if="dataUserTimeOut && dataUserTimeOut > 0" size="small" class="ml-1" color="danger" @click.native="dataUserTimeOut = 0">Remove

        </vs-button>
              </span>

        <vs-slider :max="60" :min="10" v-model="dataUserTimeOut" />
        <!-- <vs-input  v-model="dataSignupCode" /> -->

          <!-- <div class="mb-base">
                    <ul class="centerx">
                      <li class="flex">
                         <label  class="mt-3">Use Signup Code </label>
                          <vs-input class="ml-6" v-model="dataSignupCode" />
                      </li>
                      <li  style="float:right; cursor:pointer" class="text-primary" >
                        <small @click="ResetSignup">Reset code</small>
                        <small  v-clipboard:copy="dataSignupCode"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError" class="ml-5">Copy</small>
                      </li>
                    
                    </ul>
          </div> -->
          <!-- <div  v-if="isSignupCode">
            <vs-checkbox v-model="dataTokenMismatch">Token Mismatch Notification</vs-checkbox><br>
            <div v-if="dataTokenMismatch">
            <label class="vs-select--label w-full">Email</label>
            <vs-input type="email" v-model="dataTokenEmail" class="w-full"> </vs-input><br>
            <label class="vs-select--label w-full">User Success Message </label>
            <vs-textarea label=""  v-model="dataSuccessText" name="message"/>
            <label class="vs-select--label w-full">User Fail Message </label>
            <vs-textarea label="" v-model="dataFailText" name="message"/>
            </div>
          </div> -->
            <div>
            <vs-checkbox v-model="dataSignupNotofication">Signup Notification</vs-checkbox>
            <div v-if="dataSignupNotofication" class="pl-2 pt-2">
            <input type="checkbox" name="" id="" v-model="emailNotification"> 
            <label class="vs-select--label w-full ">Email</label>
            <vs-input v-if="emailNotification" label="Email" type="email" v-model="dataNotificationEmail" class="w-full" @input="acceptEmail" name="email" v-validate="'email|required'"> </vs-input>
            <span  v-if="emailNotification" class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span><br>
            <input type="checkbox" name="" id="" v-model="smsNotification"> 
            <label class="vs-select--label w-full">SMS</label>
            <vs-input label="Phone" @input="acceptNumber" v-if="smsNotification" v-model="dataNotificationPhone" class="w-full"> </vs-input><br>
            <input type="checkbox" name="" id="" v-model="appNotification"> 
            <label class="vs-select--label w-full ">App</label>

            </div><br>
              <vs-row vs-w="12">
              <vs-col  vs-w="6"  vs-type="flex" vs-justify="flex-start" vs-align="flex-start">
                <label>Automatic activation of users on signup?</label>
              </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-offset="4" vs-w="2" ><vs-switch  v-model="dataSignupStatus"></vs-switch></vs-col>
           <vs-col  vs-w="12" class="mt-5">
             <span v-if="dataSignupStatus">
            <label class="vs-select--label w-full">User Success Message </label>
            <vs-textarea label=""  maxlength="150" v-model="dataSuccessText" name="message"/>
            </span>
             <span v-else>
            <label class="vs-select--label w-full">User Pending Message </label>
            <vs-textarea label="" maxlength="150" v-model="dataFailText" name="message"/>
             </span>
          </vs-col>
            </vs-row>

          </div>

      </div>

    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {GET_LOCATION_SETTING_DETAILS, UPDATE_LOCATION_SETTINGS, UPDATE_LOCATION_SIGNUP_CODE} from '@/graphql'

export default {
  props: {
    isLocationSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      LocationName: null,
      dataMaxDailyLogins: '',
      dataUserTimeOut:0,
      maxNoOfStudents: "25",
      maxNoOfUsers:'',
      dataMaxDailyLoginFeature:false,
      // isSignupCode:false,
      // dataTokenMismatch:false,
      // dataTokenEmail:null,
      dataSuccessText:null, 
      dataFailText:null,
      dataSignupNotofication:false,
      dataNotificationEmail:null,
      dataNotificationPhone:'',
      appNotification:false,
      emailNotification:false,
      smsNotification:false,
      dataSignupStatus:false,
      dataSignupCode:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      role:null,
    }
  },
  watch: {
    isLocationSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, is_signup, signup_code} = JSON.parse(JSON.stringify(this.data))
        // console.log(is_signup)
        // this.isSignupCode = is_signup
        if(signup_code){
        this.dataSignupCode = signup_code
        }
        else{
          this.ResetSignup()
        }
        this.dataId = id
        this.LocationName = name.toUpperCase()
        this.initValues()
        this.getLocationSettingData(this.dataId)

      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isLocationSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('close-sidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && (this.dataNotificationPhone == '' || this.dataNotificationPhone.length == 14)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
      acceptNumber () {
      const x = this.dataNotificationPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.dataNotificationPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    onCopy () {
      this.$vs.notify({
        title: 'Success',
        text: 'Text copied successfully',
        color: 'success',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-check-circle'
      })
    },
    onError () {
      this.$vs.notify({
        title: 'Failed',
        text: 'Error in copying text',
        color: 'danger',
        iconPack: 'feather',
        position: 'top-center',
        icon:'icon-alert-circle'
      })
    },
    initValues () {
      // if (this.data.id) return
      // this.dataId = null
      this.dataMaxDailyLogins = ''
      this.dataUserTimeOut = 0
      this.dataMaxDailyLoginFeature = ''
      this.isStudentLimit = false
      this.dataStudentLimit = 0
      // this.dataTokenMismatch = false
      // this.dataTokenEmail  = null
      this.dataSuccessText = null 
      this.dataFailText = null 
      this.dataSignupNotofication = false
      this.dataNotificationEmail = null
      this.dataNotificationPhone = ''
      this.dataSignupStatus = false
      this.appNotification = false
    },
    StatusSuccess () {
      this.$vs.notify({
        title: 'Location',
        text:  'Update successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    ResetSignup () {
      this.dataSignupCode = "L"+Math.random().toString().slice(2, 10)
      this.$apollo
        .mutate({
          mutation: UPDATE_LOCATION_SIGNUP_CODE,
          variables: {
            id :this.dataId,
            code: this.dataSignupCode
          }
        })
        .then(response => {
          if (response.data.updateLocationSignupCode.status === 'Success') {
            //  this.StatusSuccess()
          }
        }).catch(error => {
          console.log(error)
        })

    },
    getLocationSettingData (id) {
      this.$apollo
        .mutate({
          mutation: GET_LOCATION_SETTING_DETAILS,
          variables: {
            id
          }
        })
        .then(response => {
          if (response.data.getLocationSettingData != null) {

            if (response.data.getLocationSettingData.status == 'SUCCESS') {
              console.log(response)
              if(response.data.getLocationSettingData.max_no_of_students > 0){
                 this.maxNoOfStudents = response.data.getLocationSettingData.max_no_of_students
              }
              this.maxNoOfUsers = response.data.getLocationSettingData.max_no_of_users
              this.dataMaxDailyLogins = response.data.getLocationSettingData.max_daily_logins

              if (response.data.getLocationSettingData.enable_max_login_feature == 1) {
                this.dataMaxDailyLoginFeature = true
              } else {
                this.dataMaxDailyLoginFeature = false
                this.dataMaxDailyLogins = 0

              }
              if (response.data.getLocationSettingData.user_time_out == 0 || response.data.getLocationSettingData.user_time_out==null) {
                this.dataUserTimeOut = 0
              } else {
                this.dataUserTimeOut = response.data.getLocationSettingData.user_time_out
              }
            // this.dataTokenMismatch = response.data.getLocationSettingData.is_token_mismatch
            // this.dataTokenEmail = response.data.getLocationSettingData.toke_email
            this.dataFailText = response.data.getLocationSettingData.token_fail_msg
            this.dataSuccessText = response.data.getLocationSettingData.token_succes_msg
            this.dataSignupNotofication = response.data.getLocationSettingData.is_signup_notification
            this.dataNotificationEmail = response.data.getLocationSettingData.signup_notification_email
            if(response.data.getLocationSettingData.signup_notification_phone){
                this.dataNotificationPhone = response.data.getLocationSettingData.signup_notification_phone
            }
            else{
              this.dataNotificationPhone=''
            }
            this.appNotification = response.data.getLocationSettingData.appNotification
            this.emailNotification = response.data.getLocationSettingData.emailNotification
            this.smsNotification = response.data.getLocationSettingData.smsNotification
            this.dataSignupStatus = response.data.getLocationSettingData.signup_status
            }
          } else {
            this.maxNoOfStudents = "25"
            this.maxNoOfUsers = 0
            this.dataMaxDailyLogins = 0
            this.dataUserTimeOut = 0
            this.dataMaxDailyLoginFeature = 1

          }

        })

    },
    submitData () {
      this.$apollo
        .mutate({
          mutation: UPDATE_LOCATION_SETTINGS,
          variables: {
            id: this.dataId,
            max_no_of_students: this.maxNoOfStudents,
            max_no_of_users: this.maxNoOfUsers,
            max_logins: this.dataMaxDailyLogins,
            time_out: this.dataUserTimeOut,
            max_login_feature: this.dataMaxDailyLoginFeature,
            // is_token_mismatch:this.dataTokenMismatch,
            // toke_email:this.dataTokenEmail,
            token_succes_msg:this.dataSuccessText,
            token_fail_msg:this.dataFailText,
            is_signup_notification:this.dataSignupNotofication,
            signup_notification_email:this.dataNotificationEmail,
            signup_notification_phone:this.dataNotificationPhone,
            signup_status:this.dataSignupStatus,
            emailNotification:this.emailNotification,
            smsNotification:this.smsNotification,
            appNotification:this.appNotification,
            // isSignupCode:this.isSignupCode
          }
        }).then(response => {
          if (response) {
            this.successNotificationUpdate()
            this.$emit('close-sidebar')
          }
        }).catch(error => {
          console.log(error)
        })


    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    setMaxDailyLogins () {
      this.dataMaxDailyLogins = 1
    },
    successNotificationUpdate () {
      this.$vs.notify({
        title: 'Setting',
        text: 'Saved successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    successNotification () {
      this.$vs.notify({
        title: 'Reset Daily Logins',
        text: 'Users` number of logins have been reset for the day.',
        color: 'success',
        position: 'top-right'
      })
    },
    NotAlloweddNotification () {
      this.$vs.notify({
        title: 'Not Allowed',
        text: 'Only greater than 0 value allowed',
        color: 'danger',
        position: 'top-right'
      })
    }
  },
  created(){
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      this.role=userRole[0].name
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
